import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { ClipLoader } from "react-spinners";

const HomeRedirect = () => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      // Check if session is active
      const sessionActive = sessionStorage.getItem('sessionActive');
      const wasRefresh = performance.getEntriesByType('navigation')[0]?.type === 'reload';

      if (!sessionActive && !wasRefresh) {
        // Session not active and not a refresh, redirect to login
        setLoading(false);
        return;
      }

      // Set session as active if it's a refresh
      if (!sessionActive && wasRefresh) {
        sessionStorage.setItem('sessionActive', 'true');
      }

      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/user/get-user`,
          { withCredentials: true }
        );

        if (response.data.success) {
          setUser(response.data.user);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return <ClipLoader className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === "admin") {
    return <Navigate to="/users" replace />;
  } else if (user.role === "recruiter") {
    return <Navigate to="/recruiter-dashboard" replace />;
  }

  return <Navigate to="/login" replace />;
};

export default HomeRedirect;